import * as yup from 'yup';
import AnimalType from '../../../../../enums/animal-type';

export const OptionNulable = yup.object().shape({
  value: yup.string().nullable(),
});

export const createSchema = (
  tp: (key: string, params?: { [key: string]: string | number }) => string
) =>
  yup.object().shape({
    event_type: yup.string().required(),
    species: OptionNulable,
    barn_ldc_nr: OptionNulable,
    animal_id: OptionNulable,
    status: yup.string().required(),
    period: yup.boolean(),
    date: yup.mixed().when('period', {
      is: false,
      then: yup.date().required(),
      otherwise: yup.mixed(),
    }),
    date_from: yup.mixed().when('period', {
      is: true,
      then: yup.date().required('events.date_required'),
      otherwise: yup.mixed(),
    }),
    date_to: yup.mixed().when('period', {
      is: true,
      then: yup
        .date()
        .required()
        .test('is-greater', tp('events.dates_required'), function (value) {
          const { date_from } = this.parent;
          return value > date_from;
        }),
      otherwise: yup.mixed(),
    }),
    sire_id_number: yup
      .object()
      .shape({
        value: yup.string().required(),
        label: yup.string().required(),
      })
      .nullable()
      .required(),
    sire_name: yup.string().nullable(),
    sire_breed: yup.string().nullable(),
    artificial_insemination_practitioner: yup.string().nullable(),
    certificate_number: yup.string().nullable(),
    cost: yup
      .number()
      .nullable()
      .when('event_type', {
        is: (value) => value !== AnimalType.seeding,
        then: yup.number().nullable().min(0),
        otherwise: yup.number().nullable(),
      }),
    notes: yup.string().max(4000).nullable(),
    file: yup.mixed(),
  });
